module.exports = __webpack_public_path__ + "img/khanfm.bdcdad27.png";